<template>
  <div class="container">
    <!-- 顶部大图 -->
    <!-- <div ata-wow-delay="0.2s" class="wow fadeInUp">132456</div> -->
    <div class="banner" id="banner">
      <div class="main">
        <div class="wow fadeInUp" ata-wow-delay="0.2s">
          <img class="text_img" src="../../assets/image/zt.png" />
          <div class="btn_dow btn" @click="showDownload">
            <span>下载租小六APP</span>
            <img src="../../assets/image/jt.png" class="qrcode_img" />
          </div>
        </div>
        <!-- ../../assets/image/fz.png -->
        <img
          src="https://image.manzu365.com/storage/image/202603/16/xjh1PWBZ7rIVVeFAZpZ3OfJnoUGx2hS8UfuNAq1H.png"
          class="fz"
          ref="fz"
        />
      </div>
    </div>
    <!-- 平台核心优势 -->
    <div class="advantage_out" id="advantage">
      <div class="advantage">
        <div class="title wow fadeInUp" ata-wow-delay="0.2s">
          <img src="../../assets/image/btzs.png" />
          <span>平台核心优势</span>
          <img src="../../assets/image/btzs.png" />
        </div>
        <div class="advantage_main">
          <div class="adv_list_item">
            <div class="adv_bg adv_bg_1">
              <img src="../../assets/image/hlfy.png" class="adv_icon" />
              <div class="adv_title">海量真房源，开箱即用</div>
              <div class="adv_intr">
                专业 BD 团队实地验房、拍摄、上架。您无需扫楼，
                登录系统即可分销全城优质房源。
              </div>
            </div>
          </div>
          <div class="adv_list_item">
            <div class="adv_bg adv_bg_2">
              <img src="../../assets/image/jzky.png" class="adv_icon" />
              <div class="adv_title">精准客源，免费派单</div>
              <div class="adv_intr">
                平台全网推广获取意向客户，专职自动分配看房行程。您无需
                买端口、无需打陌拜电话。
              </div>
            </div>
          </div>
          <div class="adv_list_item">
            <div class="adv_bg adv_bg_3">
              <img src="../../assets/image/yjyj.png" class="adv_icon" />
              <div class="adv_title">佣金月结，准时到账</div>
              <div class="adv_intr">
                每月固定结算日，后台可查每一笔佣金进度。 规则透明，绝无克扣。
              </div>
            </div>
          </div>
          <div class="adv_list_item">
            <div class="adv_bg adv_bg_4">
              <img src="../../assets/image/zc.png" class="adv_icon" />
              <div class="adv_title">10 分钟注册，当天开单</div>
              <div class="adv_intr">
                App操作极简，无需复杂培训。新人也能快速匹配 房源与客户。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 为什么选择我们 -->
    <div class="about_us" id="about_us">
      <div class="about_main">
        <div class="title wow fadeInUp" ata-wow-delay="0.2s">
          <img src="../../assets/image/btzs.png" />
          <span>为什么选择我们</span>
          <img src="../../assets/image/btzs.png" />
        </div>
        <div class="about_content wow fadeIn" ata-wow-delay="0.4s">
          <div class="about_item w-152 wow fadeInUp" ata-wow-delay="0.6s">
            <div class="about_item_title">对比维度</div>
            <div class="about_item_title about_item_sub_title">房源获取</div>
            <div class="about_item_title about_item_sub_title">客户来源</div>
            <div class="about_item_title about_item_sub_title">工作内容</div>
            <div class="about_item_title about_item_sub_title">佣金结算</div>
            <div class="about_item_title about_item_sub_title bt_none">
              入驻门槛
            </div>
          </div>
          <!-- 传统中介/门店模式 - 添加翻转效果 -->
          <div class="about_item w-295 wow fadeInUp" ata-wow-delay="0.8s">
            <div class="card-flip">
              <div class="card-inner">
                <div class="card-front">
                  <div class="about_item_title">传统中介/门店模式</div>
                  <div class="about_item_title about_item_sub_title">
                    <div class="about_item_t pl_46">
                      <img src="../../assets/image/dc_1.png" />
                      <img src="../../assets/image/dc_2.png" />
                    </div>
                    <div>需自己扫楼、打电话、维护业主关系</div>
                  </div>
                  <div class="about_item_title about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dc_1.png" />
                    </div>
                    <div>自费买端口、发传单、打陌拜电话</div>
                  </div>
                  <div class="about_item_title about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dc_1.png" />
                    </div>
                    <div>找房 + 找客 + 带看 + 签约 + 售后</div>
                  </div>
                  <div class="about_item_title about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dc_1.png" />
                    </div>
                    <div>周期长（可能季度结）、扣点多</div>
                  </div>
                  <div class="about_item_title about_item_sub_title bt_none">
                    <div class="about_item_t">
                      <img src="../../assets/image/dc_1.png" />
                    </div>
                    <div>需坐班、交押金、买社保</div>
                  </div>
                </div>
                <div class="card-back">
                  <div class="back-content">
                    <div class="back-icon">❌</div>
                    <div class="back-title">传统模式痛点</div>
                    <div class="back-desc">
                      成本高、效率低、<br />压力大、收入不稳定
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 本平台合作模式 - 添加翻转效果 -->
          <div class="about_item w-295 wow fadeInUp" ata-wow-delay="1.0s">
            <div class="card-flip">
              <div class="card-inner">
                <div class="card-front">
                  <div class="about_item_title bt_f">本平台合作模式</div>
                  <div class="about_item_title bt_f about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dg_1.png" />
                    </div>
                    <div>平台 BD 统一采集、维护</div>
                  </div>
                  <div class="about_item_title bt_f about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dg_1.png" />
                    </div>
                    <div>平台网推统一获客、派单</div>
                  </div>
                  <div class="about_item_title bt_f about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dg_1.png" />
                    </div>
                    <div>核心专注：带看 + 签约</div>
                  </div>
                  <div class="about_item_title bt_f about_item_sub_title">
                    <div class="about_item_t">
                      <img src="../../assets/image/dg_1.png" />
                    </div>
                    <div>月结、规则透明</div>
                  </div>
                  <div
                    class="about_item_title bt_f about_item_sub_title bt_none"
                  >
                    <div class="about_item_t">
                      <img src="../../assets/image/dg_1.png" />
                    </div>
                    <div>时间自由、无押金</div>
                  </div>
                </div>
                <div class="card-back card-back-success">
                  <div class="back-content">
                    <div class="back-icon">✅</div>
                    <div class="back-title">平台模式优势</div>
                    <div class="back-desc">
                      成本低、效率高、<br />时间自由、收入稳定
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="about_item w-295 wow fadeInUp" ata-wow-delay="1.2s">
            <div class="about_item_title">经纪人获益</div>
            <div class="about_item_title about_item_sub_title">
              <div class="about_item_t">
                <img src="../../assets/image/dg_2.png" />
              </div>
              <div>专注带看，节省大量精力</div>
            </div>
            <div class="about_item_title about_item_sub_title">
              <div class="about_item_t">
                <img src="../../assets/image/dg_2.png" />
              </div>
              <div>获客成本降为 0</div>
            </div>
            <div class="about_item_title about_item_sub_title">
              <div class="about_item_t">
                <img src="../../assets/image/dg_2.png" />
              </div>
              <div>工作更纯粹，压力更小</div>
            </div>
            <div class="about_item_title about_item_sub_title">
              <div class="about_item_t">
                <img src="../../assets/image/dg_2.png" />
              </div>
              <div>现金流更稳定</div>
            </div>
            <div class="about_item_title about_item_sub_title bt_none">
              <div class="about_item_t">
                <img src="../../assets/image/dg_2.png" />
              </div>
              <div>兼职/全职均可，灵活度高</div>
            </div>
          </div>
          <!-- 背景 -->
          <div class="about_mask wow zoomIn"></div>
        </div>
      </div>
    </div>

    <!-- 您需要做什么？ -->
    <div class="what_do" id="what_do">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="../../assets/image/btzs.png" />
        <span>您需要做什么？</span>
        <img src="../../assets/image/btzs.png" />
      </div>
      <div class="what_do_main">
        <div class="what_do_item what_do_item_1">
          <div class="what_do_text">专业带看</div>
          <div class="what_do_desc">按预约时间带客户看房。</div>
        </div>
        <div class="what_do_item what_do_item_2">
          <div class="what_do_text">促成签约</div>
          <div class="what_do_desc">发挥您的销售专长，完成 租赁签约。</div>
        </div>
        <div class="what_do_item what_do_item_3">
          <div class="what_do_text">维护服务</div>
          <div class="what_do_desc">协助客户办理入住，提升 满意度。</div>
        </div>
      </div>
    </div>

    <!-- 入驻加盟 -->
    <div class="franchise" id="franchise">
      <div class="franchise_main">
        <div class="title wow fadeInUp">
          <img src="../../assets/image/btzs.png" />
          <span>入驻加盟</span>
          <img src="../../assets/image/btzs.png" />
        </div>
        <div class="franchise_list">
          <div class="franchise_item">
            <img src="../../assets/image/xzapp.png" />
            <div class="franchise_des">下载APP</div>
          </div>
          <img src="../../assets/image/jt@2x.png" class="zb" />
          <div class="franchise_item">
            <img src="../../assets/image/txxx.png" />
            <div class="franchise_des">填写信息注册成为经纪人</div>
          </div>
          <img src="../../assets/image/jt@2x.png" class="zb" />
          <div class="franchise_item">
            <img src="../../assets/image/fx.png" />
            <div class="franchise_des">从平台获取房源信息并分销</div>
          </div>
          <img src="../../assets/image/jt@2x.png" class="zb" />
          <div class="franchise_item">
            <img src="../../assets/image/khqy.png" />
            <div class="franchise_des">客户签约</div>
          </div>
          <img src="../../assets/image/jt@2x.png" class="zb" />
          <div class="franchise_item">
            <img src="../../assets/image/hqyj.png" />
            <div class="franchise_des">获取佣金</div>
          </div>
        </div>
        <div class="franchise_footer">
          <div class="franchise_btn btn" @click="showDownload">
            立即免费入驻
          </div>
          <div>
            已有 <span class="count-num" ref="brokerCount">0</span>+
            经纪人加入，本月人均增收
            <span class="count-money" ref="incomeAmount">¥0.00</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 基础定义 -->
    <div class="definition" id="definition" v-if="false">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="../../assets/image/btzs.png" />
        <span>基础定义</span>
        <img src="../../assets/image/btzs.png" />
      </div>
      <div class="definition_table">
        <table class="data-table">
          <thead>
            <tr>
              <th>术语</th>
              <th>定义</th>
              <th>示例</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in tableData" :key="index">
              <td>
                {{ item.term }}
              </td>
              <td>{{ item.definition }}</td>
              <td>{{ item.example }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="rule rule_t">
        单笔订单佣金 = 月租金 (R) × (佣金比例系数 (K) / 12) × 租期月份 (M)
      </div>
      <div class="rule rule_b">阶梯规则配置表</div>
      <div class="definition_table">
        <table class="data-table">
          <thead>
            <tr>
              <th>阶梯等级</th>
              <th>月度总业绩月份 (Sum_M)</th>
              <th>佣金比例系数 (K)</th>
              <th>通俗解释</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in ruleTableData" :key="index">
              <td class="w-180">
                {{ item.level }}
              </td>
              <td class="w-336">{{ item.month }}</td>
              <td class="w-336">{{ item.proportion }}</td>
              <td class="w-336">{{ item.Introduction }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 经纪人成长体系 -->
    <div class="system" id="system">
      <div class="title wow fadeInUp" ata-wow-delay="0.2s">
        <img src="@/assets/image/btzs.png" />
        <span>经纪人成长体系</span>
        <img src="@/assets/image/btzs.png" />
      </div>
      <div class="system_main">
        <img
          src="https://image.manzu365.com/storage/image/202603/19/BecRslb9f2qyqs0VGFuVOoNlkheTt8yEuCuMX252.png"
          alt=""
          class="top"
        />
        <div class="system_list">
          <div class="system_list_item">
            <img src="@/assets/image/qtd.png" alt="" class="item_icon" />
            <div class="item_b sys_item_1">
              <span class="sys_item_t">青铜档</span>
              <span class="sys_item_des">基础佣金，相当于标准佣金的 8 折</span>
            </div>
          </div>
          <div class="system_list_item">
            <img src="@/assets/image/byd.png" alt="" class="item_icon" />
            <div class="item_b sys_item_2">
              <span class="sys_item_t">白银档</span>
              <span class="sys_item_des">标准佣金，相当于 1 个月租金/年</span>
            </div>
          </div>
          <div class="system_list_item">
            <img src="@/assets/image/hjd.png" alt="" class="item_icon" />
            <div class="item_b sys_item_3">
              <span class="sys_item_t">黄金档</span>
              <span class="sys_item_des"
                >奖励佣金，相当于标准佣金的 1.2 倍</span
              >
            </div>
          </div>
          <div class="system_list_item">
            <img src="@/assets/image/zsd.png" alt="" class="item_icon" />
            <div class="item_b sys_item_4">
              <span class="sys_item_t">钻石档</span>
              <span class="sys_item_des"
                >站上收益顶端，获得更高佣金回报，同样成交，赚得更多</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 成功案例 -->
    <div class="case" id="case">
      <div class="case_main">
        <div class="title wow fadeInUp" ata-wow-delay="0.2s">
          <img src="../../assets/image/btzs.png" />
          <span>成功案例</span>
          <img src="../../assets/image/btzs.png" />
        </div>
        <div class="case_list">
          <div
            class="case_item"
            :class="{ case_active: item.active }"
            v-for="(item, index) in caseList"
            :key="index"
            @mouseenter="handleMouseEnter(index)"
            @mouseleave="handleMouseLeave()"
          >
            <div
              class="case_item_title"
              :class="{ case_color_active: item.active }"
            >
              {{ item.title }}
            </div>
            <div class="case_line">
              <div class="case_line_t"></div>
              <div class="case_line_b"></div>
            </div>
            <div
              class="case_item_i"
              v-for="(item2, index2) in item.contentList"
              :key="index2"
            >
              <div class="case_item_i_t">{{ item2.title }}</div>
              <div class="case_item_i_b">
                <div v-for="(item3, index3) in item2.content" :key="index3">
                  {{ item3 }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 遮罩层 -->
    <div class="mask" v-if="showMask">
      <div class="mask_main">
        <div class="gb">
          <img src="../../assets/img/gb.png" @click="showMask = false" />
        </div>
        <div class="anpg">
          <img
            src="../../assets/img/anxz.png"
            alt=""
            @click="donwnload(1)"
            class="btn"
          />
          <img
            src="../../assets/img/pgxz.png"
            alt=""
            @click="donwnload(2)"
            class="btn"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { infoVersion } from "@/api/index";
import { mapState } from "vuex";
export default {
  data() {
    return {
      currentType: null,
      showMask: false,
      androidPath: null,
      iosPath: null,
      brokerCountAnimated: false, // 经纪人数量是否已执行动画
      incomeAmountAnimated: false, // 收入金额是否已执行动画
      franchiseAnimated: false, // 入驻加盟流程是否已执行动画
      systemAnimated: false, // 经纪人成长体系是否已执行动画
      tableData: [
        {
          term: "月租金 (R)",
          definition: "租赁合同中约定的每月租金金额",
          example: "5,000 元",
        },
        {
          term: "租期月份 (M)",
          definition: "租赁合同总时长（按月计算）",
          example: "12 个月、6 个月、18 个月",
        },
        {
          term: "单笔佣金 (C_single)",
          definition: "单个订单理论应得佣金",
          example: "见下方公式",
        },
        {
          term: "月度总业绩月份 (Sum_M)",
          definition: "经纪人当月所有已生效订单的租期月份之和",
          example: "订单 A(12 月) + 订单 B(12 月) = 24 月",
        },
        {
          term: "佣金比例系数 (K)",
          definition: "根据 Sum_M 所在阶梯确定的百分比",
          example: "80%、100%、120%",
        },
      ],
      ruleTableData: [
        {
          level: "青铜档",
          month: "Sum_M < 120",
          proportion: "80%",
          Introduction: "基础佣金，相当于标准佣金的 8 折",
        },
        {
          level: "白银档",
          month: "120 ≤ Sum_M < 180",
          proportion: "100%",
          Introduction: "标准佣金，相当于 1 个月租金/年",
        },
        {
          level: "黄金档",
          month: "Sum_M ≥ 180",
          proportion: "120%",
          Introduction: "奖励佣金，相当于标准佣金的 1.2 倍",
        },
      ],
      caseList: [
        {
          title: "案例一：新人经纪人30天成交20单",
          active: true,
          contentList: [
            {
              title: "背景",
              content: [
                "广州自由经纪人李先生，入行仅3个月，缺乏稳定房源渠道。",
              ],
            },
            {
              title: "使用租小六后",
              content: ["通过平台获取真实房源，并快速发布到自己的客户渠道。"],
            },
            {
              title: "成果",
              content: [
                "30天成交20单租赁",
                "平均成交周期缩短40%",
                "月收入突破1.5万元",
              ],
            },
            {
              title: "客户评价",
              content: [
                "以前找房源要打很多电话，现在平台直接就有，效率高很多。",
              ],
            },
          ],
        },
        {
          title: "案例二：经纪人打造稳定客源池",
          active: false,
          contentList: [
            {
              title: "背景",
              content: [
                "深圳独立经纪人王女士，主要依靠朋友圈和熟客成交，客源有限。",
              ],
            },
            {
              title: "使用租小六后",
              content: ["通过平台房源推广与分享功能，持续获取租客咨询。"],
            },
            {
              title: "成果",
              content: [
                "每月稳定 40+租客咨询",
                "成交率提升 3倍",
                "半年累计成交132单",
              ],
            },
            {
              title: "客户评价",
              content: ["房源集中、真实，客户信任度明显更高。"],
            },
          ],
        },
        {
          title: "案例三：团队经纪人协作成交",
          active: false,
          contentList: [
            {
              title: "背景",
              content: ["厦门某经纪团队（5人），房源和客源信息分散。"],
            },
            {
              title: "使用租小六后",
              content: ["统一在平台管理房源并进行协作推广。"],
            },
            {
              title: "成果",
              content: [
                "房源共享率提升 80%",
                "带看效率提升 60%",
                "团队月成交 翻倍",
              ],
            },
            {
              title: "客户评价",
              content: ["平台让房源共享更简单，合作成交更顺畅。"],
            },
          ],
        },
      ],
      caseCurrent: 0,
      timer: null,
    };
  },
  mounted() {
    var wow = new this.$wow.WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();

    // 监听滚动事件，控制 fz 动画重复触发
    this.$nextTick(() => {
      this.handleScrollAnimation();
      window.addEventListener("scroll", this.handleScrollAnimation);
      // 检查数字滚动
      this.checkNumberScroll();
      window.addEventListener("scroll", this.checkNumberScroll);
    });

    //开启定时器
    this.initTimer();
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener("scroll", this.handleScrollAnimation);
    window.removeEventListener("scroll", this.checkNumberScroll);

    //销毁定时器
    this.clearTimer();
  },
  methods: {
    initTimer() {
      this.timer = setInterval(() => {
        this.caseCurrent += 1;
        if (this.caseCurrent >= 3) {
          this.caseCurrent = 0;
        }
        this.handleMouseEnter(this.caseCurrent, false);
      }, 2000);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    donwnload(type) {
      if (type == 1) {
        //安卓
        window.open(this.androidPath);
      } else if (type == 2) {
        //苹果
        // alert('功能暂未开放')
        // 租小六
        window.open("https://testflight.apple.com/join/ZSsZFWZh");
      }
    },
    showDownload() {
      this.getVersion("android", 3);
      this.showMask = true;
    },
    getVersion(mode, type) {
      let data = {
        mode: mode,
        type: type,
      };
      infoVersion(data).then((res) => {
        if (mode == "android") {
          this.androidPath = res.data.file_path;
        }
      });
    },
    handleScrollAnimation() {
      const fzElement = this.$refs.fz;
      if (!fzElement) return;
      const rect = fzElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      // 使用更大的缓冲区域，避免在边界附近抖动
      // 当元素顶部进入视口 80% 位置时触发，离开视口上方 20% 时才移除
      const enterThreshold = windowHeight * 0.8; // 进入阈值
      const leaveThreshold = -windowHeight * 0.2; // 离开阈值（元素完全离开视口上方）
      if (rect.top < enterThreshold && rect.bottom > 0) {
        // 进入视口，添加动画类
        if (!fzElement.classList.contains("animate")) {
          fzElement.classList.add("animate");
        }
      } else if (rect.top < leaveThreshold) {
        // 只有当元素完全离开视口上方一段距离后才移除动画类
        if (fzElement.classList.contains("animate")) {
          fzElement.classList.remove("animate");
        }
      }
    },
    checkNumberScroll() {
      const franchiseList = document.querySelector(".franchise_list");
      if (!franchiseList) return;

      const rect = franchiseList.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // 当 franchise_list 进入视口时触发动画（元素顶部到达视口 70% 位置）
      if (rect.top < windowHeight * 0.7 && rect.bottom > 0) {
        // 执行数字滚动动画
        if (!this.brokerCountAnimated) {
          this.animateNumber(this.$refs.brokerCount, 0, 1208, 2000);
          this.brokerCountAnimated = true;
        }
        if (!this.incomeAmountAnimated) {
          this.animateMoney(this.$refs.incomeAmount, 0, 12000, 2000);
          this.incomeAmountAnimated = true;
        }
        // 触发入驻加盟流程动画
        if (!this.franchiseAnimated) {
          this.triggerFranchiseAnimation();
          this.franchiseAnimated = true;
        }
      }

      const systemList = document.querySelector(".system_main");
      const rect2 = systemList.getBoundingClientRect();
      if (rect2.top < windowHeight * 0.7 && rect2.bottom > 0) {
        //触发经纪人成长体系动画
        if (!this.systemAnimated) {
          this.triggerSystemAnimation();
          this.systemAnimated = true;
        }
      }
    },
    // 数字滚动动画
    animateNumber(element, start, end, duration, suffix = "") {
      if (!element) return;

      const startTime = performance.now();
      const updateNumber = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // 使用 easeOutExpo 缓动函数
        const easeProgress =
          progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        const current = Math.floor(start + (end - start) * easeProgress);
        element.textContent = current.toLocaleString() + suffix;
        if (progress < 1) {
          requestAnimationFrame(updateNumber);
        }
      };
      requestAnimationFrame(updateNumber);
    },
    // 金额滚动动画
    animateMoney(element, start, end, duration) {
      if (!element) return;

      const startTime = performance.now();

      const updateMoney = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // 使用 easeOutExpo 缓动函数
        const easeProgress =
          progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);

        const current = (start + (end - start) * easeProgress).toFixed(2);
        element.textContent =
          "¥" +
          parseFloat(current).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

        if (progress < 1) {
          requestAnimationFrame(updateMoney);
        }
      };

      requestAnimationFrame(updateMoney);
    },
    // 触发入驻加盟流程动画
    triggerFranchiseAnimation() {
      const items = document.querySelectorAll(
        ".franchise_list > .franchise_item, .franchise_list > .zb",
      );
      // console.log("找到元素数量:", items.length);

      items.forEach((item, index) => {
        // 根据索引设置不同的延迟时间，并添加动画
        const delay = index * 0.2;
        const isZb = item.classList.contains("zb");
        const animationType =
          "fadeInRight 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55)";

        item.style.animation = `${animationType} ${delay}s forwards`;
        // console.log(`元素 ${index}:`, {
        //   className: item.className,
        //   isZb: isZb,
        //   animation: item.style.animation,
        // });
      });
    },
    // 触发入驻加盟流程动画
    triggerSystemAnimation() {
      const items = document.querySelectorAll(".system_list_item");
      items.forEach((item, index) => {
        // 根据索引设置不同的延迟时间，并添加动画
        const delay = index * 0.3;
        const animationType =
          "bounceIn 0.9s cubic-bezier(0.68, -0.55, 0.265, 1.55)";
        item.style.animation = `${animationType} ${delay}s forwards`;
      });
    },

    handleMouseEnter(index, flag = true) {
      this.caseList.forEach((item, i) => {
        if (index == i) {
          item.active = true;
          this.caseCurrent = index;
          if (flag) {
            this.clearTimer();
          }
        } else {
          item.active = false;
        }
      });
    },
    handleMouseLeave() {
      this.initTimer();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../common/css/index.scss";
</style>
